<template>
  <div class="del" :class="pathClass">
    <slot></slot>
    <div class="recommend flex-js-ac" v-if="star > 0">
      <span class="f11">官方精选</span>
      <span class="star flex-ac">
      <img v-for="index in parseInt(star)" src="/static/images/community/star.png">
    </span>
    </div>
  </div>
</template>

<script>
	export default {
		name: "star",
    props: {
		  star: {
		    type: String,
        default: '0'
      },
      pathClass: {
		    type: Array,
        default: function () {
          return []
        }
      }
    }
	}
</script>

<style scoped lang="scss">
  .del {
    z-index: 1;
    position: absolute;
    right: 0;
    left: 0;
    bottom: 0;
    >img {
      width: 0.28rem;
      height: 0.28rem;
      margin-left: 80%;
      margin-bottom: 0.06rem;
    }
  }
  .recommend {
    line-height: 0.16rem;
    padding: 0 0.1rem;
    /*background: #2E83E5;*/
    background: linear-gradient(270deg, rgba(255, 253, 242, .9) 0%, rgba(255, 237, 202, .9) 100%);
    color: #222222;
    .star img {
      width: 0.09rem;
      height: 0.09rem;
      margin-left: 0.03rem;
      display: inline-block;
    }
  }
  .detail {
    position: relative;
    .recommend {
      padding: 0.04rem 0.11rem;
      border-radius: 0.04rem 0.04rem 0 0;
      margin-top: 0.1rem;
      span {
        font-size: 0.14rem;
        font-weight: 500;
      }
      .star img {
        width: 0.14rem;
        height: 0.14rem;
        margin-left: 0.08rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/star.vue